module.exports = __webpack_public_path__ + "img/NL158.7b2f5978.png";